import { useEffect, useState } from 'react';

function Header({ brand, navigation, activeSection }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavClick = (event, id) => {
    event.preventDefault();
    const target = document.getElementById(id);

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    setIsMenuOpen(false);
  };

  useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }

    const handleKeydown = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('keydown', handleKeydown);
    return () => document.removeEventListener('keydown', handleKeydown);
  }, [isMenuOpen]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', isMenuOpen);
    return () => {
      document.body.classList.remove('menu-open');
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <header className="landing-header" aria-label="Site header">
      <div className="container header-inner">
        <a
          href="#hero"
          className="brand"
          onClick={(event) => handleNavClick(event, 'hero')}
          aria-label="Go to top"
        >
          {brand}
        </a>

        <button
          type="button"
          className="menu-toggle"
          onClick={() => setIsMenuOpen((prev) => !prev)}
          aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={isMenuOpen}
          aria-controls="landing-nav"
        >
          <span />
          <span />
          <span />
        </button>

        <button
          type="button"
          className={`nav-overlay ${isMenuOpen ? 'open' : ''}`}
          onClick={() => setIsMenuOpen(false)}
          aria-label="Close menu overlay"
          aria-hidden={!isMenuOpen}
          tabIndex={isMenuOpen ? 0 : -1}
        />

        <nav
          id="landing-nav"
          className={`nav ${isMenuOpen ? 'nav-open' : ''}`}
          aria-label="Primary navigation"
        >
          <button
            type="button"
            className="menu-close"
            onClick={() => setIsMenuOpen(false)}
            aria-label="Close menu"
          >
            Close
          </button>
          {navigation.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              className={activeSection === item.id ? 'active' : ''}
              onClick={(event) => handleNavClick(event, item.id)}
              aria-current={activeSection === item.id ? 'page' : undefined}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

export default Header;
